import {
  Assignment,
  ChildCare,
  Dashboard,
  DevicesOther,
  DirectionsCar,
  Business,
  Engineering,
  Group,
  Inventory,
  SimCard,
  // Route,
  // SafetyCheck,
  SupervisedUserCircle,
  // Troubleshoot,
  // List,
  // EmojiTransportation,
  // DirectionsBus,
  // EventSeat,
  // CreditScore,
  // TransferWithinAStation,
  // AirportShuttle,
  // LocalGasStation,
  // CallSplit,
  // LegendToggle,
} from '@mui/icons-material';
import { useBoundStore } from '../../../stores';
// import { icon } from 'leaflet';

function Items() {
  const textPool = useBoundStore((state) => state.textPool);

  // const appInstance = JSON.parse(localStorage.getItem('selectedInstance'))
  //   ? JSON.parse(localStorage.getItem('selectedInstance'))[0]?.id
  //   : JSON.parse(localStorage.getItem('instance'))[0]?.instance?.id;

  return [
    {
      id: 0,
      parent: textPool['ÜRÜNLER'],
      to: '/',
      child: [],
      icon: <Inventory />,
    },
    {
      id: 1,
      parent: "DEFTERDAR",
      to: '/definitions/dashboard',
      icon: <Engineering />,
      child: [
        // {
        //   id: 0,
        //   parent: 'ERİŞİM YÖNETİMİ',
        //   to: '/definitions/access-management',
        //   child: [
        //     {
        //       id: 0,
        //       to: '/definitions/access-management/users',
        //       name: 'Kullanıcılar',
        //     },
        //     {
        //       id: 1,
        //       to: '/definitions/access-management/roles',
        //       name: 'Roller',
        //     },
        //     {
        //       id: 2,
        //       to: '/definitions/access-management/permissions',
        //       name: 'İzinler',
        //     },
        //   ],
        // },
        {
          id: 0,
          parent: textPool['Dashboard'],
          to: '/definitions/dashboard',
          icon: <Dashboard />,
          child: null,
        },
        {
          id: 1,
          parent: "Atamalar",
          to: '/definitions/assignments',
          icon: <Assignment />,
          child: null,
        },
        {
          id: 2,
          parent: textPool['Cihazlar'],
          to: '/definitions/devices',
          icon: <DevicesOther />,
          child: null,
        },
        {
          id: 3,
          parent: "SIM Kartlar",
          to: '/definitions/simcards',
          icon: <SimCard />,
          child: null,
        },
        {
          id: 4,
          parent: "Ürünler",
          to: '/definitions/products',
          icon: <Inventory />,
          child: null,
        },
        {
          id: 5,
          parent: "Şirketler",
          to: '/definitions/companies',
          icon: <Business />,
          child: null,
        },

        {
          id: 6,
          parent: textPool['Kullanıcılar'],
          to: '/definitions/users',
          icon: <SupervisedUserCircle />,
          child: null,
        },
        // {
        //   id: 2,
        //   parent: textPool['Araçlar'],
        //   to: '/definitions/vehicles',
        //   icon: <DirectionsCar />,
        //   child: null,
        // },
        // {
        //   id: 4,
        //   parent: textPool['Sürücüler'],
        //   to: '/definitions/drivers',
        //   icon: <Group />,
        //   child: null,
        // },
      ],
    },
    // {
    // id: 2,
    // parent: textPool['ATLAS'],
    // icon: <Route />,
    // to: '/atlas/dashboard',
    // child: [
    //   {
    //     id: 0,
    //     to: '/atlas/dashboard',
    //     name: textPool['Dashboard'],
    //     icon: <Dashboard />,
    //   },
    //   {
    //     id: 1,
    //     to: '/atlas/teams',
    //     name: textPool['Takımlar'],
    //     icon: <Group />,
    //   },
    //   {
    //     id: 2,
    //     to: '/atlas/observers',
    //     name: textPool['Gözlemciler'],
    //     icon: <Troubleshoot />,
    //   },
    // {
    //   id: 3,
    //   to: '/telematics/entities',
    //   name: 'Varlıklar',
    // },
    // {
    //   id: 4,
    //   to: '/telematics/alarms',
    //   name: 'Alarmlar',
    // },
    //   ],
    // },
    // {
    //   id: 3,
    //   parent: 'FLEET',
    //   to: '/fleet/dashboard',
    //   child: [
    //     {
    //       id: 0,
    //       to: '/fleet/dashboard',
    //       name: 'Dashboard',
    //     },
    //     {
    //       id: 1,
    //       to: '/fleet/teams',
    //       name: 'Takımlar',
    //     },
    //     {
    //       id: 2,
    //       to: '/fleet/observers',
    //       name: 'Gözlemciler',
    //     },
    //     {
    //       id: 3,
    //       to: '/fleet/entities',
    //       name: 'Varlıklar',
    //     },
    //     {
    //       id: 4,
    //       to: '/fleet/alarms',
    //       name: 'Alarmlar',
    //     },
    //   ],
    // },

    // {
    //   id: 3,
    //   parent: textPool['KAVİ'],
    //   icon: <SafetyCheck />,
    //   to: '/kavi/dashboard',
    //   child: [
    //     {
    //       id: 0,
    //       to: '/kavi/dashboard',
    //       name: textPool['Dashboard'],
    //       icon: <Dashboard />,
    //     },
    //     ...(appInstance === 'amir-tr0'
    //       ? [
    //           {
    //             id: 1,
    //             to: '/kavi/pusula/dashboard',
    //             parent: textPool['Dağıtım'],
    //             instanceCanView: ['amir-tr0'],
    //             icon: <CallSplit />,
    //             child: [
    //               {
    //                 id: 0,
    //                 to: '/kavi/pusula/dashboard',
    //                 name: textPool['Dashboard'],
    //                 instanceCanView: ['amir-tr0'],
    //                 icon: <Dashboard />,
    //               },
    //               {
    //                 id: 1,
    //                 to: '/kavi/pusula/distribution',
    //                 name: textPool['Dağıtım'],
    //                 instanceCanView: ['amir-tr0'],
    //                 icon: <CallSplit />,
    //               },
    //               {
    //                 id: 2,
    //                 to: '/kavi/pusula/servicelist',
    //                 name: textPool['Servis Listesi'],
    //                 instanceCanView: ['amir-tr0'],
    //                 icon: <CreditScore />,
    //               },
    //             ],
    //           },
    //           {
    //             id: 2,
    //             to: '/kavi/card-reports',
    //             name: textPool['Kart Raporları'],
    //             instanceCanView: ['amir-tr0'],
    //             icon: <TransferWithinAStation />,
    //           },
    //           {
    //             id: 3,
    //             to: '/kavi/voyage-reports',
    //             name: textPool['Görev Raporları'],
    //             instanceCanView: ['amir-tr0'],
    //             icon: <AirportShuttle />,
    //           },
    //         ]
    //       : []),
    //     ...(appInstance === 'amir-al0'
    //       ? [
    //           {
    //             id: 1,
    //             to: '/kavi/transportation-safety-reports',
    //             name: textPool['Görev Güvenlik Raporları'],
    //             instanceCanView: ['amir-al0'],
    //             icon: <EventSeat />,
    //           },
    //           {
    //             id: 2,
    //             to: '/kavi/vehicle-safety-reports',
    //             name: textPool['Araç Güvenlik Raporları'],
    //             instanceCanView: ['amir-al0'],
    //             icon: <DirectionsBus />,
    //           },
    //           {
    //             id: 3,
    //             to: '/kavi/fleet-safety-reports',
    //             name: textPool['Filo Güvenlik Raporları'],
    //             instanceCanView: ['amir-al0'],
    //             icon: <EmojiTransportation />,
    //           },
    //         ]
    //       : []),
    //   ],
    // },
    // {
    //   id: 4,
    //   parent: textPool['PUSULA'],
    //   icon: <LocalGasStation />,
    //   to: '/pusula/dashboard',
    //   child: [
    //     {
    //       id: 0,
    //       to: '/pusula/dashboard',
    //       name: textPool['Dashboard'],
    //       icon: <Dashboard />,
    //     },
    //     {
    //       id: 1,
    //       to: '/pusula/distribution',
    //       name: textPool['Dağıtım'],
    //       icon: <CallSplit />,
    //     },
    //   ],
    // },
    // {
    //   id: 4,
    //   parent: textPool['UMAY'],
    //   icon: <ChildCare />,
    //   instanceCanView: ['amir-al0'],
    //   to: '/umay/dashboard',
    //   child: [
    //     {
    //       id: 0,
    //       parent: textPool['DASHBOARD'],
    //       to: '/umay/dashboard',
    //       icon: <Dashboard />,
    //     },
    //     {
    //       id: 1,
    //       parent: textPool['TAKIMLAR'],
    //       to: '/umay/teams',
    //       icon: <Group />,
    //       child: [
    //         {
    //           id: 0,
    //           to: '/umay/teams/index-four',
    //           name: 'Index Four',
    //           icon: <List />,
    //         },
    //         {
    //           id: 1,
    //           to: '/umay/teams/index-five',
    //           name: 'Index Five',
    //           icon: <List />,
    //         },
    //         {
    //           id: 0, // amir-al0 için ilk id
    //           to: '/umay/teams/index-six',
    //           name: 'Index Six',
    //           icon: <List />,
    //         },
    //       ],
    //     },
    //     {
    //       id: 2,
    //       parent: textPool['GÖZLEMCİLER'],
    //       to: '/umay/observers',
    //       icon: <Troubleshoot />,
    //       child: [
    //         {
    //           id: 0,
    //           to: '/umay/observers/index-seven',
    //           name: 'Index Seven',
    //           icon: <List />,
    //         },
    //         {
    //           id: 1,
    //           to: '/umay/observers/index-eight',
    //           name: 'Index Eight',
    //           icon: <List />,
    //         },
    //         {
    //           id: 2,
    //           to: '/umay/observers/index-nine',
    //           name: 'Index Nine',
    //           icon: <List />,
    //         },
    //       ],
    //     },
    // {
    //   id: 3,
    //   parent: 'VARLIKLAR',
    //   to: '/umay/entities/1',
    //   child: [
    //     {
    //       id: 0,
    //       to: '/umay/entities/index-ten',
    //       name: 'Index Ten',
    //     },
    //     {
    //       id: 1,
    //       to: '/umay/entities/index-eleven',
    //       name: 'Index Eleven',
    //     },
    //     {
    //       id: 2,
    //       to: '/umay/entities/index-twelve',
    //       name: 'Index Twelve',
    //     },
    //   ],
    // },
    // {
    //   id: 4,
    //   parent: 'ALARMLAR',
    //   to: '/umay/alarms',
    //   child: [
    //     {
    //       id: 0,
    //       to: '/umay/alarms/index-thirteen',
    //       name: 'Index Thirteen',
    //     },
    //     {
    //       id: 1,
    //       to: '/umay/alarms/index-fourteen',
    //       name: 'Index Fourteen',
    //     },
    //     {
    //       id: 2,
    //       to: '/umay/alarms/index-fifteen',
    //       name: 'Index Fifteen',
    //     },
    //   ],
    // },
    //   ],
    // },
    // {
    //   id: 5,
    //   parent: textPool['FUEL'],
    //   icon: <LocalGasStation />,
    //   to: '/fuel/dashboard',
    //   instanceCanView: ['amir-al0'],
    //   child: [
    //     ...(appInstance === 'amir-al0'
    //       ? [
    //           {
    //             id: 0,
    //             to: '/fuel/dashboard',
    //             name: textPool['Dashboard'],
    //             icon: <Dashboard />,
    //           },
    //           {
    //             id: 1,
    //             to: '/fuel/fuel-reports',
    //             name: textPool['Yakıt Raporları'],
    //             icon: <LocalGasStation />,
    //           },
    //           {
    //             id: 2,
    //             to: '/fuel/fuel-blacklist',
    //             name: textPool['Kara Liste'],
    //             icon: <LegendToggle />,
    //           },
    //         ]
    //       : []),
    //   ],
    // },
    // {
    //   id: 6,
    //   parent: 'BİLDİRİMLER',
    //   to: '/notifications/dashboard',
    //   child: [
    //     {
    //       id: 0,
    //       to: '/notifications/dashboard',
    //       name: 'Dashboard',
    //     },
    //     {
    //       id: 1,
    //       to: '/notifications/index-five',
    //       name: 'Index Five',
    //     },
    //     {
    //       id: 2,
    //       to: '/notifications/index-six',
    //       name: 'Index Six',
    //     },
    //   ],
    // },
  ];
}
export { Items as items };
